import { register, getPrefix, getCookie } from '../../../Utils'

const NotificationPopup = el => {
  const prefix = getPrefix(el)
  const identifier = el.dataset.identifier

  const cookieName = `geistlich_popup_${identifier}`
  const closeButton = el.querySelector(`.${prefix}close-button`)

  const closePopup = e => {
    e.preventDefault()

    el.classList.remove(`${prefix}is--visible`)
    document.cookie = `${cookieName}=true; path=/; SameSite=lax; Secure`
  }

  if (!getCookie(cookieName)) {
    el.classList.add(`${prefix}is--visible`)
    closeButton.addEventListener('click', closePopup)
  }
}

register('NotificationPopup', NotificationPopup)
